import { useNavigation } from "@luce/core/adapters/navigation";
import { Card, Skeleton } from "@luce/ui";

import { useClientContacts } from "../../client-contact/gqlhooks/use-client-contacts";
import { InfoSection } from "./components/info-section";
import { joinParts } from "./lib";

export function AccountInfoDefaultContact() {
  const { push } = useNavigation();
  const { contactLists, loading } = useClientContacts();

  const primaryContact = contactLists.find((contact) => contact.isPrimary);

  return (
    <InfoSection title="Default Contact" onViewAll={() => push("/profile/contacts")}>
      {loading && <Skeleton radius="lg" className="h-20 w-full" />}
      {!loading && primaryContact && (
        <Card direction="row" gap="sm">
          <Card.Header>
            <Card.Title>{primaryContact.name}</Card.Title>
            <Card.Description>
              {joinParts(primaryContact.email, primaryContact.phone)}
            </Card.Description>
          </Card.Header>
        </Card>
      )}
    </InfoSection>
  );
}
